<template>
<div>
<el-row>
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="20">
<div class="title">
<h1>用于快速渲染与建模的3DsMax插件开发</h1>
</div>
<div class="video">
<div class="">
<video controls="" muted="" src="../assets/3dmaxplugin1.mp4">
                            我的天啊！我的视频在哪里？
                        </video>
<div class="abstract">
                            批量渲染<br/><br/><br/>
</div>
</div>
<div class="">
<video controls="" muted="" src="../assets/3dmaxplugin2.mp4">
                            我的天啊！我的视频在哪里？
                        </video>
<div class="abstract">
                            快速建模
                        </div>
</div>
</div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="10">
<div class="picture">
<img src="../assets/project5_1.jpg.webp"/>
</div>
</el-col>
<el-col :span="10">
<div class="picture">
<img src="../assets/project5_2.jpg.webp"/>
</div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
</div>
</template>

<script>
    export default {
        name: "Project1Zh"
    }
</script>

<style scoped>
    .picture img{
        width: 100%;
    }
    .sub-title{
        margin-bottom: 20px;
        font-size: 15px;
        color: #666;
        font-weight: 400;
        text-align: justify;
    }
    .text{
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;
    }
    .abstract{
        margin-top: 40px;
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;
    }
    video{
        width: 100%;
    }
    .grid-content{
        min-height: 36px;
    }
    .video{
        margin-top: 100px;
    }
    .title{
        margin-top: 100px;
        text-align: center;

    }
    .title a{
        color: #333;
    }
    .title p{
        color: #aaa;
        line-height: 30px;
    }
    .title h1{
        font-size:30px;
        font-weight: 100;
        letter-spacing:6px;
        color: #333333;
    }
</style>